import PopulationDensityChart from '../charts/PopulationDensityChart'
import ChartContainer from '../ChartContainer'
import PropTypes from 'prop-types'

const PopulationDensitySingleTile = ({isAdminPanelOpen, showChoropleth, setShowChoropleth, onMapReady}) => {
  return (
    <ChartContainer
      fullScreen={true}
      chart={PopulationDensityChart}
      chartName='PopulationDensityChart'
      isAdminPanelOpen={isAdminPanelOpen}
      showChoropleth={showChoropleth}
      setShowChoropleth={setShowChoropleth}
      onMapReady={onMapReady}
    />
  )
}

PopulationDensitySingleTile.propTypes = {
  isAdminPanelOpen: PropTypes.bool,
  showChoropleth: PropTypes.bool,
  setShowChoropleth: PropTypes.func,
  onMapReady: PropTypes.func
}

export default PopulationDensitySingleTile
